import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const SupplierBatchesRoutes: Routes = [
  {
    path: "supplier-batches",
    loadComponent: () =>
      import("./supplier-batches/supplier-batches.component").then(
        (m) => m.SupplierBatchesComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./supplier-batches-list/supplier-batches-list.component").then(
            (m) => m.SupplierBatchesListComponent,
          ),
      },
    ],
  },
];
